import { setLocale } from 'yup';

export const langKeys = {
  required: 'required',
  invalid: 'invalid',
  invalidTaxId: 'taxId.invalid',
  invalidPhone: 'phone.invalid',
  invalidEmail: 'email.invalid',
  invalidBankAccount: 'bankAccount.invalid',
  invalidBankNumber: 'bankNumber.invalid',
  length: 'length',
  min: 'min',
  max: 'max',
  integer: 'integer',
  amountDueGreaterThanAmount: 'amountDueGreaterThanAmount',
};

// messages should match /public/locales/cs/validation.json translation keys
setLocale({
  mixed: {
    required: langKeys.required,
    default: langKeys.invalid,
    notType: langKeys.required,
  },
  string: {
    length: ({ length }) => ({ key: langKeys.length, value: length }),
  },
  number: {
    integer: langKeys.integer,
    min: ({ min }) => ({ key: langKeys.min, value: min }),
    max: ({ max }) => ({ key: langKeys.max, value: max }),
  },
});
